import { Injectable } from "@angular/core";

import { combineLatest, Observable } from "rxjs";
import { map, shareReplay } from "rxjs/operators";

import { EdhRepository } from "@e-forsyning/common/edh";

import { FakturaStatus } from "../model/faktura-status.model";
import { Faktura } from "../model/faktura.model";
import { FakturagodkendelseViewModel } from "../model/fakturagodkendelse.view-model";
import { FakturagodkendelseRepository } from "./fakturagodkendelse.repository";

@Injectable({ providedIn: "root" })
export class FakturagodkendelseSandbox {
    constructor(
        private readonly fakturagodkendelseRepository: FakturagodkendelseRepository,
        private readonly edhRepository: EdhRepository
    ) {}

    public hentFakturaerTilGodkendelse(): Observable<FakturagodkendelseViewModel> {
        const fakturaer$ = this.fakturagodkendelseRepository.hentFakturaerTilGodkendelse(); // .pipe(shareReplay(1));
        const indstillinger$ = this.fakturagodkendelseRepository.hentIndstillinger();
        return combineLatest([fakturaer$, indstillinger$]).pipe(
            map(([fakturaer, indstillinger]) => ({
                fakturaer,
                sideTitel: indstillinger.sideTitel
            })),
            shareReplay(1)
        );
    }

    public hentDokumentUrler(faktura: Faktura): Promise<string[]> {
        return this.edhRepository.hentDokumentUrlerForAktuelBruger(faktura.dokumentnr).toPromise();
    }

    public afventFaktura(faktura: Faktura, kodeord: string, bemaerkning: string): Promise<void> {
        return this.fakturagodkendelseRepository.setFakturaStatus(faktura, kodeord, bemaerkning, FakturaStatus.Afventer).toPromise();
    }

    public godkendFaktura(faktura: Faktura, kodeord: string, bemaerkning: string): Promise<void> {
        return this.fakturagodkendelseRepository.setFakturaStatus(faktura, kodeord, bemaerkning, FakturaStatus.Godkendt).toPromise();
    }

    public afvisFaktura(status: FakturaStatus, faktura: Faktura, kodeord: string, bemaerkning: string): Promise<void> {
        return this.fakturagodkendelseRepository.setFakturaStatus(faktura, kodeord, bemaerkning, status).toPromise();
    }
}
